import React, { useEffect } from "react";

const ShippingDelivery = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="bg-gray-50 min-h-screen py-10 px-4 md:px-10">
      <div className="max-w-5xl mx-auto bg-white shadow-sm border border-gray-200 rounded-lg p-8 md:p-12 text-[15px] leading-relaxed text-gray-700">
        
        {/* Header */}
        <div className="border-b pb-6 mb-8">
          <h1 className="text-3xl font-extrabold text-gray-900 mb-2 uppercase tracking-tight">Shipping & Delivery Policy</h1>
          <p className="text-sm text-gray-500 italic">
            Official shipping guidelines for Maya Enterprises (Mediiapp).
          </p>
          <p className="text-sm text-gray-600 mt-4 font-semibold">Last Updated: February 2026</p>
        </div>

        {/* 1. Order Verification */}
        <section className="mb-10">
          <h2 className="text-xl font-bold text-gray-900 mb-4 border-l-4 border-green-600 pl-3">
            1. Order Processing & Prescription Verification
          </h2>
          <p className="mb-4">
            At <strong>Mediiapp</strong>, we specialize in life-critical <strong>Kidney and Liver transplant medications</strong>. Due to the nature of these pharmaceuticals, all orders are subject to the following:
          </p>
          <ul className="list-disc ml-6 space-y-2">
            <li><strong>Prescription Check:</strong> Orders are only processed after a valid prescription from a registered medical practitioner is uploaded and verified by our team.</li>
            <li><strong>Timeline:</strong> Verification typically occurs within 24-48 hours of order placement.</li>
            <li><strong>Location:</strong> All orders are dispatched from our wholesale facility in <strong>Jasola, New Delhi</strong>.</li>
          </ul>
        </section>

        {/* 2. Cold Chain Management */}
        <section className="mb-10 bg-blue-50 p-6 rounded-lg border border-blue-200">
          <h2 className="text-xl font-bold text-blue-900 mb-3 text-lg">2. Temperature-Sensitive (Cold Chain) Delivery</h2>
          <p className="text-blue-800">
            Many specialty transplant medicines require strict temperature controls (2°C to 8°C) to maintain their efficacy. Maya Enterprises utilizes specialized cold-chain packaging for such items. We strongly recommend that someone is available to receive these packages immediately upon delivery to ensure proper storage.
          </p>
        </section>

        {/* 3. Shipping Timelines */}
        <section className="mb-10">
          <h2 className="text-xl font-bold text-gray-900 mb-4 border-l-4 border-green-600 pl-3">
            3. Delivery Timelines & Partners
          </h2>
          <p className="mb-4">
            We use integrated logistics partners to provide real-time rate calculations and tracking. Estimated delivery times are as follows:
          </p>
          <div className="overflow-x-auto">
            <table className="min-w-full border border-gray-200 text-left">
              <thead className="bg-gray-100">
                <tr>
                  <th className="p-3 border">Region</th>
                  <th className="p-3 border">Estimated Time</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="p-3 border font-medium">Delhi NCR</td>
                  <td className="p-3 border">Same Day / Next Day</td>
                </tr>
                <tr>
                  <td className="p-3 border font-medium">Major Metro Cities</td>
                  <td className="p-3 border">2 - 4 Business Days</td>
                </tr>
                <tr>
                  <td className="p-3 border font-medium">Rest of India</td>
                  <td className="p-3 border">5 - 7 Business Days</td>
                </tr>
              </tbody>
            </table>
          </div>
        </section>

        {/* 4. Tracking and Charges */}
        <section className="mb-10">
          <h2 className="text-xl font-bold text-gray-900 mb-4 border-l-4 border-green-600 pl-3">
            4. Order Tracking & Shipping Charges
          </h2>
          <ul className="list-disc ml-6 space-y-2">
            <li><strong>Tracking:</strong> Once shipped, an Airway Bill (AWB) number will be provided. You can use this to track your order via our website.</li>
            <li><strong>Charges:</strong> Shipping fees are calculated based on weight, distance, and specialized packaging (cold chain) requirements. These are visible in your cart before checkout.</li>
          </ul>
        </section>

        {/* 5. Contact Info */}
        <section className="mt-10 pt-8 border-t border-gray-200">
          <p className="font-bold text-gray-900">Biller & Dispatch Office:</p>
          <p className="font-medium text-green-700">Maya Enterprises</p>
          <p>GF-39, Omaxe Square, Jasola, New Delhi - 110025</p>
          <p>Director: Dheeraj Khatwani</p>
          <p>Support Email: <span className="text-green-600 font-bold">Mediiappindia@gmail.com</span></p>
        </section>
      </div>
    </div>
  );
};

export default ShippingDelivery;